export const inquiryRejectionTooltipText =
  "This product's company currently does not accept inquiries.";

export const doesCompanyRejectInquiries = (companyKey?: string) => {
  return companyKey === 'provital';
};
